<div class="modal fade" id="kt_modal_freight_manager_add_edit" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered mw-650px">
    <div class="modal-content">
      <div class="modal-header p-3 d-flex justify-content-between bg-secondary">
        <h2 class="fw-bold m-0">{{ isEditMode ? 'Update Freight Manager' : 'Add Freight Manager' }}</h2>
        <div class="btn btn-icon btn-sm btn-active-icon-primary" data-bs-dismiss="modal">
          <i class="ki-duotone ki-cross fs-1">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
        </div>
      </div>

      <form [formGroup]="freightManagerForm" (ngSubmit)="onSubmit()" novalidate>
        <div class="modal-body p-5">
          <div class="row">
            <!-- From Country -->
            <div class="col-md-6 mb-5">
              <label class="form-label required">From Country</label>
              <select
                class="form-select form-select-solid"
                formControlName="from_country_id"
                [class.is-invalid]="from_country_id?.invalid && from_country_id?.touched"
                [disabled]="isLoadingCountries">
                <option value="">Select From Country</option>
                <option *ngFor="let country of countries" [value]="country.code">
                  {{ country.name }}
                </option>
              </select>
              <div *ngIf="from_country_id?.invalid && from_country_id?.touched" class="invalid-feedback">
                <div *ngIf="from_country_id?.errors?.['required']">From Country is required</div>
              </div>
            </div>

            <!-- To Country -->
            <div class="col-md-6 mb-5">
              <label class="form-label required">To Country</label>
              <select
                class="form-select form-select-solid"
                formControlName="to_country_id"
                [class.is-invalid]="to_country_id?.invalid && to_country_id?.touched"
                [disabled]="isLoadingCountries">
                <option value="">Select To Country</option>
                <option *ngFor="let country of countries" [value]="country.code">
                  {{ country.name }}
                </option>
              </select>
              <div *ngIf="to_country_id?.invalid && to_country_id?.touched" class="invalid-feedback">
                <div *ngIf="to_country_id?.errors?.['required']">To Country is required</div>
              </div>
            </div>

            <!-- To Port -->
            <div class="col-md-6 mb-5">
              <label class="form-label required">To Port</label>
              <select
                class="form-select form-select-solid"
                formControlName="to_port_id"
                [class.is-invalid]="to_port_id?.invalid && to_port_id?.touched"
                [disabled]="isLoadingPorts || !to_country_id?.value">
                <option value="">{{ !to_country_id?.value ? 'Select To Country first' : 'Select To Port' }}</option>
                <option *ngFor="let port of ports" [value]="port._id">
                  {{ port.name }}
                </option>
              </select>
              <div *ngIf="to_port_id?.invalid && to_port_id?.touched" class="invalid-feedback">
                <div *ngIf="to_port_id?.errors?.['required']">To Port is required</div>
              </div>
            </div>

            <!-- Shipper -->
            <div class="col-md-6 mb-5">
              <label class="form-label required">Shipper</label>
              <select
                class="form-select form-select-solid"
                formControlName="shipper_id"
                [class.is-invalid]="shipper_id?.invalid && shipper_id?.touched"
                [disabled]="isLoadingShippers">
                <option value="">Select Shipper</option>
                <option *ngFor="let ship of shippers" [value]="ship._id">
                  {{ ship.name }}
                </option>
              </select>
              <div *ngIf="shipper_id?.invalid && shipper_id?.touched" class="invalid-feedback">
                <div *ngIf="shipper_id?.errors?.['required']">Shipper is required</div>
              </div>
            </div>

            <!-- Region -->
            <div class="col-md-6 mb-5">
              <label class="form-label required">Region</label>
              <select
                class="form-select form-select-solid"
                formControlName="region_id"
                [class.is-invalid]="region_id?.invalid && region_id?.touched"
                [disabled]="isLoadingRegions">
                <option value="">Select Region</option>
                <option *ngFor="let reg of regions" [value]="reg._id">
                  {{ reg.name }}
                </option>
              </select>
              <div *ngIf="region_id?.invalid && region_id?.touched" class="invalid-feedback">
                <div *ngIf="region_id?.errors?.['required']">Region is required</div>
              </div>
            </div>

            <!-- Booking Agent -->
            <div class="col-md-6 mb-5">
              <label class="form-label">Booking Agent</label>
              <div class="d-flex gap-2">
                <select
                  class="form-select form-select-solid"
                  formControlName="booking_agent_id"
                  [disabled]="isLoadingBookingAgents">
                  <option value="">Select Booking Agent</option>
                  <option *ngFor="let agent of bookingAgents" [value]="agent._id">
                    {{ agent.name }}
                  </option>
                </select>
                <button
                  type="button"
                  class="btn btn-icon btn-light-primary"
                  (click)="openAddBookingAgentModal()"
                  title="Add Booking Agent">
                  <i class="ki-duotone ki-plus fs-2"></i>
                </button>
              </div>
            </div>

            <!-- Type (Hidden, set based on selected tab) -->
            <div class="col-md-6 mb-5">
              <label class="form-label required">Type</label>
              <input
                type="text"
                class="form-control form-control-solid"
                formControlName="type"
                readonly
                [value]="selectedType === 'roro' ? 'RORO' : 'CTN'"
              />
            </div>

            <!-- Memo -->
            <div class="col-md-12 mb-5">
              <label class="form-label">Memo</label>
              <textarea
                class="form-control form-control-solid"
                formControlName="memo"
                rows="3"
                placeholder="Enter memo (optional)">
              </textarea>
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-light" data-bs-dismiss="modal">Cancel</button>
          <button
            type="submit"
            class="btn btn-primary"
            [disabled]="isLoading">
            <span *ngIf="isLoading" class="spinner-border spinner-border-sm align-middle me-2"></span>
            {{ isEditMode ? 'Update' : 'Add' }} Freight Manager
          </button>
        </div>
      </form>
    </div>
  </div>
</div>

<!-- Booking Agent Add/Edit Modal -->
<app-add-edit-booking-agent
  (bookingAgentAdded)="onBookingAgentAdded()">
</app-add-edit-booking-agent>
